import React from 'react'
import InfoBuildingType from './InfoBuildingType';
import InfoBuiltSize from './InfoBuiltSize';
import InfoLeanTo from './InfoLeanTo';
import InfoWalls from './InfoWalls';
import InfoDoorWindow from './InfoDoorWindow';
import InfoColors from './InfoColors';
import InfoInsulation from './InfoInsulation';
import InfoOptions from './InfoOptions';
import InfoNotesExtra from './InfoNotesExtra';
import InfoPayment from './InfoPayment';

const InformationTooltip = ({activeTab, show, handleClose, top, height}) => {

    const infoComponentList = {
        'buildingtypetab': <InfoBuildingType />,
        'buildsizes': <InfoBuiltSize />,
        'buildsizes_left': <InfoBuiltSize />,
        'buildsizes_right': <InfoBuiltSize />,
        'buildsizes_front': <InfoBuiltSize />,
        'buildsizes_back': <InfoBuiltSize />,
        'leantos': <InfoLeanTo />,
        'walls': <InfoWalls />,
        'doorwindow': <InfoDoorWindow />,
        'colors': <InfoColors />,
        'insulation': <InfoInsulation />,
        'options': <InfoOptions />,
        'notesextra': <InfoNotesExtra />,
        'taxdeposit': <InfoPayment />,
    }

    const infoTitleList = {
        'buildingtypetab': 'Building Type',
        'buildsizes': 'Built & Size',
        'buildsizes_left': 'Built & Size',
        'buildsizes_right': 'Built & Size',
        'buildsizes_front': 'Built & Size',
        'buildsizes_back': 'Built & Size',
        'leantos': 'Lean-To',
        'walls': 'Sides & Ends',
        'doorwindow': 'Doors & Windows',
        'colors': 'Colors',
        'insulation': 'Insulation',
        'options': 'Options',
        'notesextra': 'Notes & Extra',
        'taxdeposit': 'Payments',
    }

    const ChildComponent = () => {
        if(activeTab !== null) {
            return infoComponentList[activeTab];
        }
        return null;
    }
    
    return (
        (activeTab !== null && show) &&
        <div className='information-tooltip' style={{top}}>
            <span className='icon-cross-ico' onClick={() => handleClose()}></span>
            <div className='mobile-info-header'>
                <span>{infoTitleList[activeTab]}</span>
            </div>
            <div className='tooltip-container' style={{maxHeight: height}}>
                <ChildComponent />
            </div>
        </div>
    )
}

export default InformationTooltip